import React from 'react';
import { NavigationItemType } from '../../../models';
import { block } from '../../../utils';
import { getItemClickHandler } from '../../utils';
import NavigationDropdownItem from '../NavigationDropdownItem/NavigationDropdownItem';
import NavigationItem from '../NavigationItem/NavigationItem';
import './NavigationListItem.css';
const b = block('navigation-list-item');
export const NavigationListItem = ({ item, className, index, activeItemId, highlightActiveItem, hidePopup, column, onActiveItemChange, }) => {
    const id = `${column}-${index}`;
    const isActive = id === activeItemId;
    const onClick = getItemClickHandler({
        column,
        index,
        activeItemId,
        onActiveItemChange,
    });
    return (React.createElement("li", { className: b(null, className) },
        item.type === NavigationItemType.Dropdown ? (React.createElement(NavigationDropdownItem, { className: b('content'), data: item, onClick: onClick, isActive: isActive, hidePopup: hidePopup })) : (React.createElement(NavigationItem, { className: b('content'), data: item, onClick: onClick })),
        highlightActiveItem && isActive && (React.createElement("div", { className: b('slider-container') },
            React.createElement("div", { className: b('slider') })))));
};
